module.exports = __webpack_public_path__ + "fonts/fa-brands-400.4a5d4d8.eot";